import { Skeleton } from "@/components/ui/skeleton";

const EnrollmentSkeleton = () => {
  return (
    <div>
      <Skeleton
        className="mx-auto mb-2"
        style={{ width: "80%", height: "24px" }}
      />
      <Skeleton className="my-1" style={{ width: "100%", height: "16px" }} />
      <Skeleton className="my-8" style={{ width: "100%", height: "16px" }} />

      {Array.from({ length: 2 }).map((_, index) => (
        <div key={index} className="my-4">
          <Skeleton className="mb-2" style={{ width: "50%", height: "12px" }} />

          <Skeleton style={{ width: "100%", height: "120px" }} />
        </div>
      ))}
    </div>
  );
};

export default EnrollmentSkeleton;
